var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.437,
    height: 55.49,
    viewBox: "0 0 36.437 55.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Attachment",
    transform: "translate(-999.235 -449.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4486",
    "data-name": "Group 4486"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4950",
    "data-name": "Path 4950",
    d: "M1035.172,504H999.735V455.284h9.8",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4951",
    "data-name": "Path 4951",
    d: "M1027.154,455.284h8.018V504",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1935",
    "data-name": "Line 1935",
    x2: 19.402,
    transform: "translate(1007.752 476.3)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1936",
    "data-name": "Line 1936",
    x2: 19.402,
    transform: "translate(1007.752 482.988)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1937",
    "data-name": "Line 1937",
    x2: 19.402,
    transform: "translate(1007.752 489.724)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4487",
    "data-name": "Group 4487"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4952",
    "data-name": "Path 4952",
    d: "M1011.875,457.511l7.173-7.172a3.437,3.437,0,0,1,2.479-1.025h0a3.5,3.5,0,0,1,2.479,5.983l-7.172,7.173a2.665,2.665,0,1,1-3.77-3.769l6.578-6.578a1.6,1.6,0,0,1,1.138-.468h0a1.545,1.545,0,0,1,1.126.468,1.618,1.618,0,0,1,0,2.276l-4.781,4.782",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4953",
    "data-name": "Path 4953",
    d: "M1013.5,459l3.042,3.041A2.151,2.151,0,1,1,1013.5,459Z",
    fill: "#6c5b7b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/Attachment-icon.bc66523d9b6ac643024a7083879e43b3.svg";
export { ForwardRef as ReactComponent };